import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import I18n from 'I18n';
import styled from 'styled-components';
import { LORAX, SLINKY } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { H3 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIProgress from 'UIComponents/progress/UIProgress';
import { LimitToI18nKey } from 'pricing-pages-lib/constants/Ebx638Features';
import { FeatureTooltip } from './LimitUsageSection';
export const LimitUsageItemContainer = styled.div.withConfig({
  displayName: "LimitUsageFeatureRow__LimitUsageItemContainer",
  componentId: "sc-9pbygp-0"
})(["margin:48px 0;display:flex;flex-direction:column;"]);
export const Header = styled.div.withConfig({
  displayName: "LimitUsageFeatureRow__Header",
  componentId: "sc-9pbygp-1"
})(["max-height:28px;display:flex;flex-direction:row;align-items:center;"]);
export const LimitUsageFeatureRow = props => {
  const {
    limit,
    usage,
    limitName
  } = props.limitUsage;
  const {
    name,
    nextTierLimit,
    subtitle
  } = LimitToI18nKey[limitName];
  const featureName = I18n.text(`pricing-pages.features.${name}.name`).toLocaleLowerCase();
  const percentage = usage / limit * 100;
  return /*#__PURE__*/_jsxs(LimitUsageItemContainer, {
    children: [/*#__PURE__*/_jsx(UIProgress, {
      descriptiveLabel: /*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "upgrade",
          size: 24,
          color: LORAX,
          style: {
            marginRight: '8px'
          }
        }), /*#__PURE__*/_jsx(FeatureTooltip, {
          name: name,
          children: /*#__PURE__*/_jsx(H3, {
            style: {
              marginBottom: '5px'
            },
            "aria-level": 3,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EBX638.LimitUsageSection.featureLimit.title",
              options: {
                featureName,
                usage,
                limit
              }
            })
          })
        })]
      }),
      value: percentage,
      valueLabel: /*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 300,
          color: SLINKY
        },
        children: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: percentage
        })
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `EBX638.LimitUsageSection.featureLimit.${subtitle}`,
      options: {
        featureName,
        newLimit: nextTierLimit
      },
      className: "align-self-start"
    })]
  });
};